export const SITE_URL = 'https://webstazy.one';
export const SITE_NAME = 'Webstazy One';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/img/wbstazyfav.png`;

export interface RouteSeo {
    title: string;
    description: string;
    keywords?: string;
    noindex?: boolean;
}

export const NOT_FOUND_SEO: RouteSeo = {
    title: 'Page Not Found | Webstazy One',
    description: 'The page you are looking for could not be found. Head back to the Webstazy One homepage or explore our services.',
    noindex: true
};

export const DEFAULT_SEO: RouteSeo = {
    title: 'Webstazy One — Web, Mobile & Cloud Solutions for Modern Businesses',
    description: 'Webstazy One is a Sri Lanka-based digital partner helping startups and established businesses go online with web design, mobile apps, cloud solutions, digital infrastructure, and digital media marketing.',
    keywords: 'Webstazy One, web design Sri Lanka, mobile app development, cloud solutions, digital marketing, digital infrastructure, e-commerce, software development'
};

export const ROUTE_SEO: Record<string, RouteSeo> = {
    '/': DEFAULT_SEO,

    '/services': {
        title: 'Our Services — Web, Mobile, Cloud, Marketing | Webstazy One',
        description: 'Explore Webstazy One services: web design and development, mobile apps, custom cloud-based solutions, digital infrastructure, and digital media marketing.',
        keywords: 'web design services, mobile app services, cloud solutions, digital marketing services, IT services Sri Lanka'
    },
    '/contact': {
        title: 'Contact Us | Webstazy One',
        description: 'Get in touch with Webstazy One. Visit our Pitakotte or Colombo offices, email info@webstazy.one, or call +94 112 186 555.',
        keywords: 'contact Webstazy One, customer support, Sri Lanka office'
    },

    '/privacy-policy': {
        title: 'Privacy Policy | Webstazy One',
        description: 'How Webstazy One collects, uses, and protects your personal information across our websites and services.',
        keywords: 'privacy policy, data protection, Webstazy One'
    },
    '/terms-conditions': {
        title: 'Terms & Conditions | Webstazy One',
        description: 'The terms and conditions governing your use of Webstazy One websites, products, and services.',
        keywords: 'terms and conditions, terms of service, Webstazy One'
    },

    '/service-custom-cloudbased-sol': {
        title: 'Custom Cloud-Based Solutions | Webstazy One',
        description: 'Bespoke cloud applications, SaaS platforms, and scalable cloud infrastructure designed and engineered by Webstazy One.',
        keywords: 'custom cloud solutions, SaaS development, cloud applications, cloud engineering'
    },
    '/service-digital-infrastructure': {
        title: 'Digital Infrastructure & Business Process Management | Webstazy One',
        description: 'Modernize your digital infrastructure and streamline business processes with Webstazy One — networking, systems integration, and BPM.',
        keywords: 'digital infrastructure, business process management, BPM, systems integration'
    },
    '/service-digital-media': {
        title: 'Digital Media Marketing | Webstazy One',
        description: 'Grow your brand with Webstazy One digital media marketing — SEO, social media, paid ads, and content strategy.',
        keywords: 'digital marketing, SEO, social media marketing, content marketing, paid advertising'
    },
    '/service-mobile-application': {
        title: 'Mobile Application Development | Webstazy One',
        description: 'Native and cross-platform mobile app development for iOS and Android by Webstazy One — from concept to App Store.',
        keywords: 'mobile app development, iOS development, Android development, cross-platform apps'
    },
    '/service-web-design': {
        title: 'Web Design & Development | Webstazy One',
        description: 'Custom websites, e-commerce stores, and web applications crafted by Webstazy One to grow your brand and revenue online.',
        keywords: 'web design, web development, e-commerce, custom websites, responsive design'
    },
    '/showcase': {
        title: 'Showcase — Our Work & Portfolio | Webstazy One',
        description: 'Explore a curated showcase of Webstazy One projects across web, mobile, cloud, and digital media.',
        keywords: 'portfolio, showcase, case studies, Webstazy One work'
    },
    '/ventures/fort-mart': {
        title: 'Fort Mart — A Webstazy One Venture',
        description: 'Fort Mart, a venture by Webstazy One — learn about the platform, mission, and how it serves its market.',
        keywords: 'Fort Mart, Webstazy ventures, e-commerce venture'
    }
};
